<template>
    <div>
        <v-container grid-list-xs>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-actions>
                            <BackButton />
                        </v-card-actions>
                        <v-card-text>
                            <v-subheader class="text-subtitle-1 font-weight-bold">CONSENT TO ELECTRONIC DISCLOSURES AND SIGNATURES</v-subheader>
                            Please read this Consent to Electronic Disclosures and Signatures (the "Consent") carefully and retain a copy for your records.  By checking the box and clicking "AGREE TO PROCEED" you agree to execute and/or receive electronically all documents and communications (collectively, the "Documents") that in any way relate to any transaction or potential transaction with Participating Creditors (collectively, the "Services"), including, but not limited to the following Documents: (1) this Consent; (2) the Prequalification Terms and Conditions (3) the Arbitration Provision; (4) disclosures and Terms of Use on our website; (5) our privacy policies and notices, including notices under the California Consumer Privacy Act; (6) any or other disclosure required by applicable federal, state or local law; (7) letters, notices, statements or alerts regarding the foregoing that we provide to you relating to any present or future accounts that you establish with us; and (8) any updates to previously listed agreements, policies, disclosures, authorizations, or other notices.  As used in this Consent, the word "we," "us" and "our" refers to Aspen Dental together with its parents, subsidiaries, successors, assigns, agents, and service providers, and Participating Creditors, and the words "you," and "your" mean each person accessing Services with or through us.
                            <br>
                            <br>
                            <b><i>Requesting Paper Delivery of Documents</i></b>
                            You have the right to request a paper copy of Documents, however, after agreeing to this Consent, we will not provide you with paper (non-electronic) copies of any Documents unless specifically requested by you.  To request paper copies of any Documents, please contact your applicable <a href="/#/docs/participatingCreditors/#creditor-table">creditor</a>.
                            <br>
                            <br>
                            <b><i>Terms of Consent</i></b>
                            This Consent covers all Services applied for or obtained with or through us.
                            <br>
                            <br>
                            <b><i>Updating Information or Withdrawal of Electronic Acceptance of Disclosures and Notices</i></b>
                            <br>
                            <br>
                            You may update your information that we use to contact you electronically or withdraw your consent to receive statements in electronic form by contacting your applicable <a href="/#/docs/participatingCreditors/#creditor-table">creditor</a>.
                            <br>
                            <br>
                            <b><i>Signature</i></b>
                            <br>
                            <br>
                            You agree that an electronic facsimile of your signature or your electronic agreement carries the full legal weight of a written signature and that any electronic signature, contract or other record relating to your Account or, without limitation, any other agreement or transaction with us, will be given full legal effect, validity and enforceability as if it was in writing.
                            <br>
                            <br>
                            <b><i>Federal Law</i></b>
                            <br>
                            <br>
                            You acknowledge and agree that your consent to electronic Documents is being provided in connection with a transaction affecting interstate commerce that is subject to the federal Electronic Signatures in Global and National Commerce Act and that you and we both intend that the Act apply to the fullest extent possible to validate our ability to conduct business with you by electronic means.
                            <br>
                            <br>
                            <b><i>Termination / Changes</i></b>
                            We reserve the right, in our sole discretion, to terminate or change the terms and conditions on which we provide electronic Documents.  We will provide you with notice of any such termination or change as required by law.
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .v-card__text {
        color: #000000 !important;

        .theme--light.v-subheader {
            color: #000000;
        }
    }


</style>
